import React from 'react';
import styled from 'styled-components';
import Alert from 'gatsby-theme-core/src/components/alert';

const ErrorAlert = (props) => (
  <Alert {...props} $danger>
    Er is helaas iets mis gegaan, probeer het later nog eens.
  </Alert>
);

export default styled(ErrorAlert)``;
